<template>
  <div class="checkout-items">
    <b-card
      v-for="(item, index) in items"
      :key="index"
      class="ecommerce-card py-2"
      no-body
    >
      <template v-if="item.model_type != 'penalty'">
        <div class="item-img">
          <b-link
            :to="{
              name: `${
                item.model_type.includes('semester')
                  ? 'show-semester'
                  : item.model_type.includes('course')
                  ? 'show-course'
                  : 'show-penalty'
              }`,
              params: {
                id: item.model_id,
              },
            }"
          >
            <b-img
              @error="setAltImg"
              height="200px"
              :src="item.model.banner || errorImage"
              :alt="`${item.model.name}-${item.model.id}`"
            />
          </b-link>
        </div>

        <b-card-body>
          <div class="d-flex justify-content-between">
            <div class="item-name">
              <h6 class="mb-0">
                <b-link
                  :to="{
                    name: `${
                      item.model_type.includes('semester')
                        ? 'show-semester'
                        : item.model_type.includes('course')
                        ? 'show-course'
                        : 'show-penalty'
                    }`,
                    params: {
                      id: item.model_id,
                    },
                  }"
                  class="text-body"
                >
                  {{ item.model.name }}
                </b-link>
              </h6>
            </div>

            <div class="d-flex">
              <span> وضعیت : </span>
              
              <b-badge
                :variant="item.model.active ? 'success' : 'danger'"
                class="rounded"
              >
                {{ item.model.active ? "فعال" : "غیر فعال" }}
              </b-badge>
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <div class="d-flex text-muted my-1" v-if="item.model.started_at">
              <span
                ><feather-icon size="14" icon="CalendarIcon" /> تاریخ شروع :
              </span>
              
              <span>{{ calcDate(item.model.started_at) }}</span>
            </div>
            <div class="d-flex text-muted my-1" v-if="item.model.ended_at">
              <span
                ><feather-icon size="14" icon="CalendarIcon" /> تاریخ پایان :
              </span>
              
              <span>{{ calcDate(item.model.ended_at) }}</span>
            </div>
          </div>
          <div v-if="item.model.brief_description">
            <div
              v-html="item.model.brief_description"
              class="text-justify py-1"
            />
          </div>
        </b-card-body>

        <div class="item-options text-center">
          <div class="item-wrapper">
            <div class="item-cost">
              <p
                class="item-price text-danger"
                style="text-decoration: line-through"
                v-if="Number(item.rebate) > 0"
              >
                {{ numberWithCommas(item.model.amount) }}
              </p>
              <h4 class="card-text shipping">
                <b-badge pill variant="light-success">
                  {{ numberWithCommas(finalAmount(item)) }} تومان
                </b-badge>
              </h4>
            </div>
          </div>
          <!-- <b-button
          variant="light"
          class="mt-1 remove-wishlist"
          @click="removeProductFromCartClick(product)"
        >
          <feather-icon icon="XIcon" class="mr-50" />
          <span>Remove</span>
        </b-button>
        <b-button
          variant="primary"
          class="btn-cart move-cart"
          @click="toggleProductInWishlist(product)"
        >
          <feather-icon
            icon="HeartIcon"
            class="mr-50"
            :class="{ 'fill-current': product.isInWishlist }"
          />
          <span class="text-nowrap">Wishlist</span>
        </b-button> -->
        </div>
      </template>
      <template v-else>
        <div class="item-img">
          <b-link
            :to="{
              name: `${
                item.model_type.includes('semester')
                  ? 'show-semester'
                  : item.model_type.includes('course')
                  ? 'show-course'
                  : 'show-penalty'
              }`,
              params: {
                id: item.model_id,
              },
            }"
          >
            <b-img
              @error="setAltImg"
              height="200px"
              :src="item.model.banner || errorImage"
              :alt="`${item.model.name}-${item.model.id}`"
            />
          </b-link>
        </div>
        <b-card-body>
          <div class="d-flex justify-content-between">
            <div class="item-name">
              <div class="mb-0">
                <b-badge variant="danger" class="my-50">جریمه</b-badge>
                <div class="my-50">دوره : {{ item.model.course.name }}</div>
                <div class="my-50">جلسه : {{ item.model.session.name }}</div>
                <div class="my-50">تمرین : {{ item.model.exercise.title }}</div>
              </div>
            </div>
          </div>
        </b-card-body>
        <div class="item-options text-center">
          <div class="item-wrapper">
            <div class="item-cost">
              <p
                class="item-price text-danger"
                style="text-decoration: line-through"
                v-if="Number(item.rebate) > 0"
              >
                {{ numberWithCommas(item.model.amount) }}
              </p>
              <h4 class="card-text shipping">
                <b-badge pill variant="light-success">
                  {{ numberWithCommas(finalAmount(item)) }} تومان
                </b-badge>
              </h4>
            </div>
          </div>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BFormSpinbutton,
  BImg,
  BLink,
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BCardBody,
    BLink,
    BImg,
    BButton,
    BBadge,
    BFormSpinbutton,
  },
  methods: {
    finalAmount(item) {
      let finalAmount = 0;
      if (item.percentage) {
        finalAmount =
          Number(item.amount) -
          (Number(item.amount) * Number(item.rebate)) / 100;
      } else {
        finalAmount = Number(item.amount) - Number(item.rebate);
      }

      return finalAmount > 0 ? String(parseInt(finalAmount)) : "0";
    },
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style></style>
